import backendUrls from "../utils/BackendUrls";
import { CALL_API } from "../utils/HTTP";

const CourseService = { 
getAllSimplesCourses: async function (params = {}) {
    const baseUrl = backendUrls.COURSE.ALL; // Base URL
    const secure = false;
    const cache = false;

    const queryParams = new URLSearchParams();
    queryParams.set("page", params?.page ?? 0);

    if (params?.numberPerPage) {
        queryParams.set("numberPerPage", params.numberPerPage);
    }

    if (params?.type) {
        queryParams.set("type", params.type);
    }

    if (params?.status) {
        queryParams.set("status", params.status);
    }

    if (params?.search) {
        queryParams.set("search", params.search);
    }

    let url = `${baseUrl}?${queryParams.toString()}`;

    // Appeler l'API
    return await CALL_API("GET", url, null, secure, cache);
},


//  searchCourse: async function (searchKeyword = null) {
//     // Base URL
//     const baseUrl = backendUrls.COURSE.ALLUNSECURECOURSE; 

//     // Créer les paramètres de requête
//     const queryParams = searchKeyword ? `?search=${encodeURIComponent(searchKeyword)}` : '';

//     // Combiner l'URL de base avec les paramètres de requête
//     const url = `${baseUrl}${queryParams}`;

//     const secure = false;
//     const cache = false;

//     // Appele API
//     return await CALL_API("GET", url, null, secure, cache);    
// },

  
searchCourse: async function (searchKeyword = null) {
    // Base URL
    const baseUrl = backendUrls.COURSE.ALLUNSECURECOURSE; 

    // Créer les paramètres de requête avec page fixe à 1
    const queryParams = `?search=${encodeURIComponent(searchKeyword || '')}&page=1`;

    // Combiner l'URL de base avec les paramètres de requête
    const url = `${baseUrl}${queryParams}`;

    const secure = false;
    const cache = false;

    // Appele API
    return await CALL_API("GET", url, null, secure, cache);    
},

getAllSessions: async function (param = null) {
    const url = backendUrls.SESSION.ALL + (param ? param : "");
    const secure = false,
      cache = false;
    return await CALL_API("GET", url, null, secure, cache);
  },
  getDetails: async function (id) {
    const url = backendUrls.COURSE.DETAILS + `/${id}`;
    const secure = false,
      cache = false;
    return await CALL_API("GET", url, null, secure, cache);
  },
  getContent: async function (id) {
    const url = backendUrls.COURSE_SESSION.DETAILS + `/${id}`;
    const secure = false,
      cache = false;
    return await CALL_API("GET", url, null, secure, cache);
  },
};

export default CourseService;
